export type TrackPoint = {
  latitude: number;
  longitude: number;
  altitude: number | null;
  accuracy: number;
  timestamp: number;
  /** Segundos de grabación activa; no avanza durante una pausa manual. */
  activeSeconds?: number;
};

import { ACTIVITY_DRAFT_STORE, openDeviceDatabase } from "./device-storage";

const STORE = ACTIVITY_DRAFT_STORE;
const LEGACY_KEY = "active-route";
const key = (ownerId: string) => `active-route:${ownerId}`;

export async function saveActivityDraft(points: TrackPoint[], seconds: number, ownerId: string) {
  if (!("indexedDB" in window)) return;
  const database = await openDeviceDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE, "readwrite");
    transaction.objectStore(STORE).put({ points, seconds, savedAt: Date.now() }, key(ownerId));
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
  database.close();
}

export async function loadActivityDraft(ownerId: string): Promise<{ points: TrackPoint[]; seconds: number; savedAt: number } | null> {
  if (!("indexedDB" in window)) return null;
  const database = await openDeviceDatabase();
  const result = await new Promise<{ points: TrackPoint[]; seconds: number; savedAt: number } | null>((resolve, reject) => {
    const store = database.transaction(STORE, "readonly").objectStore(STORE);
    const request = store.get(key(ownerId));
    request.onsuccess = () => {
      if (request.result) {
        resolve(request.result);
        return;
      }
      const legacy = store.get(LEGACY_KEY);
      legacy.onsuccess = () => resolve(legacy.result ?? null);
      legacy.onerror = () => reject(legacy.error);
    };
    request.onerror = () => reject(request.error);
  });
  database.close();
  return result;
}

export async function clearActivityDraft(ownerId: string) {
  if (!("indexedDB" in window)) return;
  const database = await openDeviceDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE, "readwrite");
    const store = transaction.objectStore(STORE);
    store.delete(key(ownerId));
    store.delete(LEGACY_KEY);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
  database.close();
}
